import request from "../Config/axios";
// -----------------------------------------------------------
export const Get_Setting_Api = async () => {
    const { data } = await request.get(
        `/Setting/Get`
    );
    return data;
};
// -----------------------------------------------------------
export const Update_Setting_Api = async (params) => {
    const { data } = await request.post(
        `/Setting/Update`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetSiteTitle_Setting_Api = async () => {
    const { data } = await request.get(
        `/Setting/GetSiteTitle`
    );
    return data;
};
// -----------------------------------------------------------
export const GetLoginPageTitle_Setting_Api = async () => {
    const { data } = await request.get(
        `/Setting/GetLoginPageTitle`
    );
    return data;
};
// -----------------------------------------------------------
export const GetRelationListId_Setting_Api = async () => {
    const { data } = await request.get(
        `/Setting/GetRelationListId`
    );
    return data;
};
// -----------------------------------------------------------
export const GetStateListId_Setting_Api = async () => {
    const { data } = await request.get(
        `/Setting/GetStateListId`
    );
    return data;
};